import styled from 'styled-components';

import OImage from '../OImage';
import fonts from '../../ui/fonts';
import { colors } from '../../ui/design-tokens';
import { BREAKPOINTS } from '../../ui/settings';
import { media, space, rems } from '../../ui/helpers';

const Module = styled.div`
  padding: 0 0 ${space(6)};

  .newsTitle {
    margin-bottom: ${space(2)};
  }

  .date {
    ${fonts.bodySM};
    color: ${colors.neutral[800]};
    margin-bottom: ${space(4)};
  }

  .image {
    width: 100%;
  }

  .text {
    border-bottom: 1px solid #ececec;
    padding-bottom: ${space(8)};
    margin-top: ${space(4)};
    padding: 0;
  }

  .backTertiary {
    flex-direction: row-reverse;
    margin-right: ${space(2)};

    &:hover {
      svg {
        right: 0;
        left: ${space(-1)};
      }
    }

    svg {
      left: 0;
      margin-left: 0;
      margin-right: ${space(1)};
      transform: rotate(180deg);
      transition: left 0.3s ease-in-out;
      will-change: left;
    }
  }

  ${media.min('medium')`
    padding: ${space(8)} 0;

    .date {
      margin-bottom: ${space(6)};
    }

    .text {
      padding-bottom: ${space(10)};
      margin-top: ${space(6)};
    }
  `}
`;

const Image = styled(OImage)`
  margin: 0 auto;
  max-width: ${rems(BREAKPOINTS.readerBreak)};
`;

export { Image, Module };
